module.exports = __webpack_public_path__ + "media/img/versandordner-6af533ae0e68b8f23c5a5a5b6dda3503.jpg";